//配置全局访问接口地址
let commonUrl = "https://api.chargespot.ltd";

let baseUrl = {
    commonUrl
}

export default baseUrl